import { render, staticRenderFns } from "./BasePaneResizer.vue?vue&type=template&id=692b0f1a"
import script from "./BasePaneResizer.vue?vue&type=script&lang=js"
export * from "./BasePaneResizer.vue?vue&type=script&lang=js"
import style0 from "./BasePaneResizer.vue?vue&type=style&index=0&id=692b0f1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports